<template>
  <div class="error-page">
    <div class="error-page-wrap">
      <div class="error-page__logo">
        <img src="@/assets/404.svg" />
      </div>

      <div class="error-page__title">
        {{ $t(errMsg) }}
      </div>
      <div class="error-page__description">
        {{ errDesc }}
      </div>
    </div>
  </div>
</template>

<script>
import customStylesHandler from '@/mixins/customStylesHandler';

export default {
  name: 'ErrorPage',

  mixins: [customStylesHandler],

  data() {
    return {
      errors: [],
      errMsg: '',
      errDesc: '',
    };
  },

  computed: {
    notFound() {
      return this.errors.length > 0;
    },
  },

  created() {
    if (this.$route.query.code) {
      this.errMsg = this.$route.query.code;
    }
  },
};
</script>
